export const testimonials = [
  {
    quote:
      "I had notes from four different courses scattered across my laptop. Having assessment worksheets and documentation templates in one place has made my pre-appointment review far more consistent.",
    name: "Maria Luna",
    role: "Aesthetic Nurse Practitioner",
    country: "United States",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/02411484-4308-428e-a9bd-8259320d57e6.jpg",
  },
  {
    quote:
      "The complications volumes are organized in a way that makes revisiting warning signs and escalation considerations much quicker. I use the comparative tables when reviewing cases with my team.",
    name: "Dr. Alejandro Ríos",
    role: "Physician, Aesthetic Medicine",
    country: "Mexico",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/c5ca6bdf-6cbd-4503-9359-11361fb54374.jpg",
  },
  {
    quote:
      "I adapted the follow-up record templates to our clinic in a single afternoon. Clear, practical, and honest about what an educational resource can and can’t do.",
    name: "Lucía Fernández",
    role: "Dentist, Facial Aesthetics",
    country: "Spain",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/0462316b-5384-45bf-b72a-acf4428e9f4c.jpg",
  },
  {
    quote:
      "After many years in practice, what I value most is structure. The Clinical Safety Audit Workbook gave us a clean format to review our emergency preparedness and documentation.",
    name: "Dr. Helen Brooks",
    role: "Aesthetic Physician",
    country: "United Kingdom",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/06617ec6-4131-42ec-9ffd-cbd71b29cd01.jpg",
  },
  {
    quote:
      "The casebook’s discussion questions are excellent for study sessions. For $27 it’s the most organized reference library I’ve added to my continuing education.",
    name: "Santiago Gómez",
    role: "Registered Nurse, Aesthetic Clinic",
    country: "Colombia",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/35c0b348-aafa-4ad3-9851-8bf497d0b67a.jpg",
  },
];
